const screenConfigurations = {
    RESOURCE: {
        translations: {
            key: "Mesaj Kodu",
            value: "Mesaj Açıklaması",
            language: "Mesaj Dili",
            resourceType: "Mesaj Türü",
        },
        order: ["key", "value", "language", "resourceType"],
        hideFields: [
            "status", "id", "systemDate", "createDate", "createUserId",
            "createUserName", "updateDate", "updateUserId", "updateUserName",
            "deleteDate", "deleteUserId", "deleteUserName", "foundationDate", "memberId", "annulmentCode",
        ]
    },
    MERCHANT: {
        translations: {
            merchantId: "Üye İşyeri",
            parentMerchantId: "Ana İşyeri",
            merchantType: "İşyeri Tipi",
            merchantName: "İşyeri Adı",
            tradeName: "İşyeri Ticari Adı",
            tradeRegistrationNumber: "Sicil No",
            commissionProfileCode: "Çalışma Grubu",
            webSite: "Web Sitesi",
            taxNumber: "Vergi Numarası",
            taxOfficeCode: "Vergi Dairesi Kodu",
            taxOfficeName: "Vergi Dairesi",
            citizenshipNumber: "Kimlik Numarası",
            mcc: "MCC",
            openingDate: "İşyeri Açılış Tarihi",
            aggreementDate: "Sözleşme Tarihi",
            closedDate: "İşyeri Kapanış Tarihi",
            phoneNumber: "Telefon No",
            description: "Açıklama",
            hashPassword: "Hashlenmiş Şifre",
            cepPos: "Cep Pos",
            pos: "Fiziksel Pos",
            vpos: "Sanal Pos",
            mobilePos: "Mobil Pos",
            iksIsSuccess: "IKS'ye Eklendi mi?",
            passiveReason: "Pasife Alma Nedeni",
            hostingCompanyCitizenNumber: "Hosting Şirket TCKN/VKN",
            hostingCompanyName: "Hosting Şirket Adı",
            annulmentStaff: "Fesih Personel Adı Soyadı",
            annulmentCodeDesc: "Fesih Nedeni",
            annulmentCode: "Fesih Nedeni",
            merchantStatusType: "İşyeri Durum Tipi"
        },
        order: ["merchantId", "parentMerchantId", "merchantType", "merchantName", "tradeName", "tradeRegistrationNumber", "commissionProfileCode", "webSite", "taxNumber", "taxOfficeCode", "taxOfficeName", "citizenshipNumber", "mcc", "openingDate", "aggreementDate", "closedDate", "phoneNumber", "description", "hashPassword", "cepPos", "pos", "vpos", "mobilePos", "iksIsSuccess", "passiveReason", "hostingCompanyCitizenNumber", "hostingCompanyName", "annulmentStaff", "annulmentCodeDesc", "annulmentCode", "merchantStatusType"],
        hideFields: [
            "status", "id", "systemDate", "createDate", "createUserId",
            "createUserName", "updateDate", "updateUserId", "updateUserName",
            "deleteDate", "deleteUserId", "deleteUserName", "foundationDate", "memberId", "annulmentCode",
        ]
    }
    ,

    COMMISSIONPARAMETER: {
        translations: {
            profileCode: "Profil Kodu",
            merchantId: "Üye İşyeri",
            merchantName: "İşyeri Adı",
            submerchantId: "Alt Üye İşyeri",
            submerchantName: "Alt Üye İşyeri",
            ıssuerCardBankCode: "Yönlendirilecek Kartın Bankası",
            txnType: "İşlem Tipi",
            onus: "Onus",
            international: "International",
            amex: "Yi Amex",
            installment: "Taksit Sayısı",
            bankcode: "Banka",
            bankName: "Banka Adı",
            bankblocked: "Banka Blokesi",
            bankblockedday: "Banka Bloke Gün",
            bankcommission: "Banka Komisyonu",
            merchantblocked: "İşyeri Blokesi",
            merchantblockedday: "İşyeri Bloke Gün",
            merchantcommission: "Üye İşyeri Komisyon Oranı",
            merchantadditionalcommission: "Üye İşyeri Ücreti",
            cardType: "Kart Tipi",
            minAmount: "Minumum Tutar",
            maxAmount: "Maksimum Tutar",
            commissionFlag: "Komisyonu Son Kullanıcıya Yansıt",
            issuerCardType: "Kart Tipi"

            // ... diğer çeviriler
        },
        order: ["profileCode", "txnType", "merchantId", "submerchantName", "onus", "international",
            , "amex", "cardType", "issuerCardType", "installment", "bankcode", "bankblocked", "bankblockedday", "bankcommission",
            "commissionFlag", "merchantblocked", "merchantblockedday", "merchantcommission", "merchantadditionalcommission",
            "minAmount", "maxAmount"
        ],
        hideFields: [
            "status", "id", "systemDate", "createDate", "createUserId",
            "createUserName", "updateDate", "updateUserId", "updateUserName",
            "deleteDate", "deleteUserId", "deleteUserName", "foundationDate", "memberId", "annulmentCode",
            "ıssuerCardBankCodes", "bankName", "merchantName", "submerchantId"
        ]
    }
    ,
    COMMISSIONPROFILE: {
        translations: {
            name: "Komisyon Adı",
            code: "Komisyon Kodu",
            description: "Açıklama",
        },
        order: ["name", "code", "description"],
        hideFields: [
            "status", "id", "systemDate", "createDate", "createUserId",
            "createUserName", "updateDate", "updateUserId", "updateUserName",
            "deleteDate", "deleteUserId", "deleteUserName", "foundationDate", "memberId", "annulmentCode",
        ]
    },

    MEMBERVPOS: {
        translations: {
            key: "Başka Anahtar",
            value: "Başka Değer",
            // ... diğer çeviriler
        },
        order: ["value", "key",],
        hideFields: [
            "status", "id", "systemDate", "createDate", "createUserId",
            "createUserName", "updateDate", "updateUserId", "updateUserName",
            "deleteDate", "deleteUserId", "deleteUserName", "foundationDate", "memberId", "annulmentCode",
        ]
    },

    USER: {
        translations: {
            fullName: "Adı Soyadı",
            username: "Kullanıcı Adı",
            email: "E-posta",
            phoneNumber: "Telefon Numarası",
            hashPassword: "Hashlenmiş Şifre",
            tryCount: "Deneme Sayısı",
            systemPassword: "Sistem Şifresi",
            memberId: "Member Id",
            merchantId: "Üye İşyeri",
            userType: "Kullanıcı Tipi",
            roleIds: "Kullanıcı Rolü "

        },
        order: ["fullName", "email", "phoneNumber", "merchantId", "userType", "roleIds" /* diğer alanlar */],
        hideFields: [
            "status", "id", "systemDate", "createDate", "createUserId",
            "createUserName", "updateDate", "updateUserId", "updateUserName",
            "deleteDate", "deleteUserId", "deleteUserName", "foundationDate", "memberId", "annulmentCode", "username", "hashPassword", "tryCount", "systemPassword"
        ]
    },

    VPOSROUTING: {
        translations: {
            profileCode: "Çalışma Grubu",
            memberId: "Member Id",
            merchantId: "Üye İşyeri",
            issuerCardBankCode: "Yönlendirilecek Kartın Bankası",
            issuerCardBankCodes: "Yönlendirilecek Kartın Bankası",
            issuerCardType: "Kart Tipi",
            merchantVposBankCode: "Yönlendirilecek Sanal POS",
            transactionSubType: "İşlem Tipi",
            onusRouting: "On Us Yönlendirilsin",
            userId: "Kullanıcı Id"
        },
        order: ["profileCode", "merchantId", "issuerCardType", "transactionSubType", "issuerCardBankCode", "merchantVposBankCode", "onusRouting", "memberId", /* diğer alanlar */],
        hideFields: [
            "status", "id", "systemDate", "createDate", "createUserId",
            "createUserName", "updateDate", "updateUserId", "updateUserName",
            "deleteDate", "deleteUserId", "deleteUserName", "foundationDate", "memberId", "annulmentCode",
            "onusRouting"
        ]
    },
    VAKIFBANKSENDMONEY: {
        translations: {
            "merchantId": "Üye İşyeri Numarası",
            "merchantName": "Üye İşyeri Adı",
            "taxNumber": "Vergi Numarası",
            "paymentDescription": "Ödeme Açıklaması",
            "transactionId": "İşlem Numarası",
            "identityNumber": "T.C. Kimlik Numarası",
            "paymentAmountFlag": "Ödeme Tutarı Türü",
            "merchantCommissionAmount": "Üye İşyeri Komisyon Tutarı",
            "currencyCode": "Para Birimi Kodu",
            "paymentAmount": "Ödeme Tutarı",
            "bankCode": "Banka Kodu",
            "iban": "IBAN",
            "endOfDayDate": "Gün Sonu Tarihi",
        },
        order: ["merchantId", "parentMerchantId", "merchantType", "merchantName", "tradeName", "tradeRegistrationNumber", "commissionProfileCode", "webSite", "taxNumber", "taxOfficeCode", "taxOfficeName", "citizenshipNumber", "mcc", "openingDate", "aggreementDate", "closedDate", "phoneNumber", "description", "hashPassword", "cepPos", "pos", "vpos", "mobilePos", "iksIsSuccess", "passiveReason", "hostingCompanyCitizenNumber", "hostingCompanyName", "annulmentStaff", "annulmentCodeDesc", "annulmentCode", "merchantStatusType"],
        hideFields: [
            "status", "id", "systemDate", "createDate", "createUserId",
            "createUserName", "updateDate", "updateUserId", "updateUserName",
            "deleteDate", "deleteUserId", "deleteUserName", "foundationDate", "memberId", "annulmentCode",
        ]
    }
};

export default screenConfigurations;